export const TRUSTPILOT_WIDGET = {
  businessUnitId: '62626b07cedb3a23f2047f57',
  templateId: '53aa8912dec7e10d38f59f36'
};
